import "./App.scss";
import React, { useState } from "react";
import "boxicons/css/boxicons.min.css";
import { Route, Routes } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import MainHome from "./pages/Home/MainHome";
import MainAbout from "./pages/About/MainAbout";
import Contact from "./pages/Contact";
import MainProjects from "./pages/Projects/MainProjects";
import {
  ThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material/styles";
import LoaderContext from "./components/LoaderContext";
import Loader from "./components/Loader/Loader";
import InteractiveCursor from "./components/InteractiveCursor";
import ParticleEffect from "./components/ParticleEffect";
import "./components/InteractiveCursor.css";

const outerTheme = createTheme({
  typography: {
    fontFamily: `Cairo, Roboto, 'Helvetica Neue', sans-serif !important`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },

  palette: {
    primary: {
      main: "#ffb510",
    },
  },
});

function App() {
  const [isLoading, setIsLoading] = useState(true);

  // const theme = createTheme();

  return (
    <LoaderContext.Provider value={{ isLoading, setIsLoading }}>
      <ThemeProvider theme={outerTheme}>
        <StyledEngineProvider injectFirst>
          <InteractiveCursor />
          <ParticleEffect count={30} color="#ffb510" />

          <Loader />
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<MainHome />} />
              <Route path="about" element={<MainAbout />} />
              <Route path="projects" element={<MainProjects />} />
              <Route path="contactMe" element={<Contact />} />
            </Route>
          </Routes>
        </StyledEngineProvider>
      </ThemeProvider>
    </LoaderContext.Provider>
  );
}

export default App;
